import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'

export const CalcForm = () => {
  
  return (
    <EntityForm />
  )
}